import React, { FormEvent, useEffect, useState } from "react"
import { Modal } from "react-bootstrap"
import Alert from "../alert"
import { StringMap } from "../../types"

interface TelegramSettingsModalProps {
  show: boolean
  isBusy: boolean
  onHide: () => void
  onSubmit: (settings: StringMap) => void
  settings: StringMap | undefined | null
}

function TelegramSettingsModal({
  settings,
  show,
  isBusy,
  onSubmit,
  onHide,
}: TelegramSettingsModalProps) {
  const initialBot =
    settings != null &&
    typeof settings !== "undefined" &&
    settings["Bot"] != null
      ? settings["Bot"]
      : ""
  const [bot, setBot] = useState(initialBot)
  useEffect(() => setBot(initialBot), [initialBot])

  const initialChannel =
    settings != null &&
    typeof settings !== "undefined" &&
    settings["Channel"] != null
      ? settings["Channel"]
      : ""
  const [channel, setChannel] = useState(initialChannel)
  useEffect(() => setChannel(initialChannel), [initialChannel])

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault()
    await onSubmit({ ...settings, Bot: bot, Channel: channel })
  }

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Telegram Settings</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Alert />
        <form onSubmit={handleSubmit}>
          <div className="form-floating mb-3">
            <input
              type="text"
              className="form-control"
              id="bot"
              placeholder="url"
              defaultValue={initialBot}
              onChange={(e) => setBot(e.target.value)}
              disabled={isBusy ? true : undefined}
              required
            />
            <label htmlFor="bot" className="text-muted">
              Bot Token
            </label>
          </div>
          <div className="form-floating mb-3">
            <input
              type="text"
              className="form-control"
              id="channel"
              placeholder="channel"
              defaultValue={initialChannel}
              onChange={(e) => setChannel(e.target.value)}
              disabled={isBusy ? true : undefined}
              required
            />
            <label htmlFor="channel" className="text-muted">
              Channel ID
            </label>
          </div>
          <div className="d-flex justify-content-between">
            <button type="submit" className="btn btn-primary btn-lg">
              Save
            </button>
            <button
              type="button"
              className="btn btn-light btn-lg"
              onClick={onHide}
            >
              Cancel
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  )
}

export default TelegramSettingsModal
